import { lazy, Fragment, Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './PdpRespHeroCarouselVimeo.scss';

const PdpRespHeroCarouselVimeoLazy = lazy(() =>
    import(
        /* webpackChunkName: "PdpRespHeroCarouselVimeo" */
        './PdpRespHeroCarouselVimeo'
    )
);

export const PdpRespHeroCarouselVimeoLazyLoader = props => {
    const [lazyLoad, setLazyLoad] = useState(props.isCurrentItem);
    if (props.isCurrentItem && !lazyLoad) {
        setLazyLoad(true);
    }
    return (
        <Fragment>
            {lazyLoad && (
                <Suspense
                    fallback={
                        <div className={styles.loadingContainer}>
                            <Spinner dark size="small" />
                            <span className={styles.loadingText}>
                                <FormattedMessage
                                    id="PdpRespHeroCarouselVimeoLoading.loadingVideo"
                                    defaultMessage="Video Loading"
                                />
                            </span>
                        </div>
                    }
                >
                    <PdpRespHeroCarouselVimeoLazy {...props} />
                </Suspense>
            )}
        </Fragment>
    );
};
PdpRespHeroCarouselVimeoLazyLoader.propTypes = {
    isCurrentItem: PropTypes.bool,
    isSmallCarousel: PropTypes.bool,
};
